import * as React from 'react';

import { Button } from '@rematter/ui-web';

import { LoadReconciliationWizard } from './_LoadReconciliationWizard';

import { useTranslations } from '~/modules/trade/i18n/useTranslations';

export interface Props {
  onMarkAsReconciled: () => Promise<void>;
  isLoading?: boolean;
  loadId?: string;
  loadNumber?: string;
  skipMaterialsReconciliation?: boolean;
}

export const LoadStatusTransitionMarkAsReconciledButton: React.FC<Props> = ({
  onMarkAsReconciled,
  isLoading,
  loadId,
  loadNumber,
  skipMaterialsReconciliation = false,
}) => {
  const t = useTranslations();
  const [isWizardOpen, setIsWizardOpen] = React.useState(false);

  const handleOpenWizard = () => {
    setIsWizardOpen(true);
  };

  const handleCloseWizard = () => {
    setIsWizardOpen(false);
  };

  const handleReconcile = async () => {
    await onMarkAsReconciled();
  };

  return (
    <div className="@LoadStatusTransitionMarkAsReconciledButton contents">
      <Button variant="solid" isLoading={isLoading} onPress={handleOpenWizard}>
        {t.loadStatusTransition.reconciliation.reconcile}
      </Button>

      <LoadReconciliationWizard
        loadId={loadId}
        loadNumber={loadNumber}
        isOpen={isWizardOpen}
        onClose={handleCloseWizard}
        onReconcile={handleReconcile}
        skipMaterialsReconciliation={skipMaterialsReconciliation}
      />
    </div>
  );
};
